import type { ICompany } from "components/contacts/contacts-types";
import { COMPANIES } from "constants/action-types";
import { progressEpic, type IRequestAction } from "epics/base-epic";
import siteConfig from "site-config";

export const fetchCompanies = progressEpic<IRequestAction, ICompany[]>(COMPANIES.FETCH, ({ payload }) => ({
    url: siteConfig.api + payload.url,
    method: "GET",
}));
